import React from '@root/vendor/react';

const AnalyticsTagContext = React.createContext(null);

export default AnalyticsTagContext;
